import { useState } from 'react';

export const useForceUpdate = () => {
  const [value, setValue] = useState<boolean>(true);
  return () => setValue(!value);
};
